enum IntegrationDirectionOptionEnum {
    BOTH = "both",
    UPSTREAM = "upstream",
    DOWNSTREAM = "downstream",
    NONE = "none",
}

export default IntegrationDirectionOptionEnum;
